import { render, staticRenderFns } from "./EMelderComponentRisikoDashboardRiskMatrix.vue?vue&type=template&id=7243d1a6"
import script from "./EMelderComponentRisikoDashboardRiskMatrix.vue?vue&type=script&lang=js"
export * from "./EMelderComponentRisikoDashboardRiskMatrix.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentRisikoDashboardRiskMatrix.vue?vue&type=style&index=0&id=7243d1a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports